// extracted by mini-css-extract-plugin
export default {"overlay":"dA-z","bodyOpen":"eA-z","content":"fA-z","header":"gA-z","close":"hA-z","closeNoHeading":"iA-z"};